import React, { FC } from "react";
import { useDivisionFilterSeed } from "@app/session-defaults/useDivisionFilterSeed";
import { Input } from "@shared/ui/input";
import { DivisionSearchSelect } from "@src/components/business-data-entry";
import { BusinessForm } from "@src/components/business-form";
import { FilterFormPanel } from "@shared/ui/form-panel";
import type { ApiDivisionFilter } from "@src/api/dictionaries/divisions";
import type { LimitCardFilter } from "@src/api/stock/limitCards";
import type { ListFilterPanelProps } from "../../../../../../shared/listFilterPanel";
import { wsLimitCardsFilterFormConfig, type WsLimitCardsFilterFormValues } from "./wsLimitCardsFilter.form-config";

const RECEIVER_DIVISION_FILTER = { AvailableFor: "Create" } satisfies ApiDivisionFilter;

/** Пропсы {@link WsLimitCardsFilterForm}. */
export type WsLimitCardsFilterFormProps = ListFilterPanelProps<LimitCardFilter>;

/**
 * Форма фильтра списка лимитных карт УП.
 */
export const WsLimitCardsFilterForm: FC<WsLimitCardsFilterFormProps> = ({ initialFilter, onApply }) => {
    const availableDivisionsSeed = useDivisionFilterSeed<WsLimitCardsFilterFormValues>("receiverCode", {
        filter: RECEIVER_DIVISION_FILTER,
    });

    return (
        <FilterFormPanel
            initialFilter={initialFilter}
            seed={availableDivisionsSeed}
            submissionMemory={{
                key: "workShop.wsLimitCards.filter",
                schemaVersion: 1,
                fields: ["receiverCode"], // "stateCodes"
            }}
            formProps={{ formConfig: wsLimitCardsFilterFormConfig }}
            toForm={(filter) => wsLimitCardsFilterFormConfig.toForm(filter)}
            toDomain={(values) => wsLimitCardsFilterFormConfig.toDomain(values)}
            onApply={onApply}
        >
            {(form) => (
                <>
                    <BusinessForm.Field name="num">
                        <Input {...form.field("num").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="senderCode">
                        <DivisionSearchSelect
                            {...form.field("senderCode").getSearchSelectProps((division) => division?.Code ?? null)}
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="receiverCode">
                        <DivisionSearchSelect
                            {...form.field("receiverCode").getSearchSelectProps((division) => division?.Code ?? null)}
                            flt={RECEIVER_DIVISION_FILTER}
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="startPeriodFrom">
                        <Input.Date {...form.field("startPeriodFrom").getDateInputProps()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="finishPeriodTo">
                        <Input.Date {...form.field("finishPeriodTo").getDateInputProps()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stockobjDescription">
                        <Input {...form.field("stockobjDescription").getPropsWithLabel()} />
                    </BusinessForm.Field>
                </>
            )}
        </FilterFormPanel>
    );
};
